import { useSelector } from 'react-redux'

import type { CheckboxListFilterProps } from '~/components/common/filters/CheckboxListFilter'
import { getInventoryOrdersFilters } from '~/store/duck/inventoryOrders'
import { getInventoryOrderShipmentStatus } from '~/store/reducers/constants'

import StatusFilter from '../filters/StatusFilter'

export interface InventoryOrderStatusFilterProps extends CheckboxListFilterProps {}

const InventoryOrderStatusFilter = (props: InventoryOrderStatusFilterProps) => {
  const inventoryOrderStatuses = useSelector(getInventoryOrderShipmentStatus)
  const inventoryOrdersFilters = useSelector(getInventoryOrdersFilters)

  return (
    <StatusFilter
      selectedStatusFilter={inventoryOrdersFilters?.status}
      statusItems={inventoryOrderStatuses}
      {...props}
    />
  )
}

export default InventoryOrderStatusFilter
